// extracted by mini-css-extract-plugin
export default {"root":"SegmentedControl_root__9TvLE","segment":"SegmentedControl_segment__sMJpv","segmentOn":"SegmentedControl_segmentOn__SSIfd","count":"SegmentedControl_count__TxQR8"};